var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background",attrs:{"id":"library"}},[_c('Banner',{attrs:{"tests":_vm.tests,"baseURL":_vm.baseURL}}),_c('Navigation'),_c('Resources',{attrs:{"tests":_vm.tests,"baseURL":_vm.baseURL}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }